import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/ultimate-creditors.js';
import q from '../query.js';
// Options for an ultimate-creditor Select, with a leading "none" entry
export const ultimateCreditorOptions = (noneLabel, ultimateCreditors) => [
    { value: '', label: noneLabel },
    ...ultimateCreditors.map((ultimateCreditor) => ({
        value: ultimateCreditor.id,
        label: `${ultimateCreditor.referenceId} - ${ultimateCreditor.name}`,
    })),
];
export const ultimateCreditorsEntity = 'ultimate-creditors';
const ultimateCreditorKey = (id) => `ultimate-creditors-${id}`;
const ultimateCreditorsByCreditorKey = (creditorId) => `ultimate-creditors-by-creditor-${creditorId}`;
export const useUltimateCreditor = (id) => q.query(ultimateCreditorKey(id), () => api.get(id), keys.read.item(ultimateCreditorsEntity, id), { enabled: id != null });
export const useUltimateCreditors = (creditorId) => q.query(ultimateCreditorsByCreditorKey(creditorId), () => api.getByCreditor(creditorId), keys.read.collection(ultimateCreditorsEntity), { enabled: creditorId != null });
//# sourceMappingURL=index.js.map